import script from "./detailList.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailList.vue?vue&type=script&lang=ts&setup=true"

import "./detailList.vue?vue&type=style&index=0&id=3c5c480a&scoped=true&lang=less"
import "./detailList.vue?vue&type=style&index=1&id=3c5c480a&lang=css"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5c480a"]])

export default __exports__